const BACKSLASH = String.fromCharCode(92)

/**
 * Repairs bidData JSON that was persisted through a non-Unicode SQL literal.
 *
 * Characters outside the column codepage are best-fit mapped by SQL Server, and
 * U+2033 (DOUBLE PRIME, as in `1,44"`) collapses to a plain double quote. That
 * happens after JSON.stringify has run, so the quote lands in the stored string
 * unescaped and breaks JSON.parse for the entire bid.
 *
 * Escapes any double quote sitting inside a string value that is not a real
 * terminator (a terminator is always followed by , : } or ]).
 */
export const repairBidDataJson = (raw) => {
    if (typeof raw !== 'string') return raw

    let out = ''
    let inString = false

    for (let i = 0; i < raw.length; i++) {
        const char = raw[i]

        if (char === BACKSLASH && inString) {
            out += char + (raw[i + 1] || '')
            i++
            continue
        }

        if (char === '"') {
            if (!inString) {
                inString = true
            } else {
                let j = i + 1
                while (j < raw.length && /\s/.test(raw[j])) j++
                if ([',', ':', '}', ']'].includes(raw[j])) {
                    inString = false
                } else {
                    out += BACKSLASH + char
                    continue
                }
            }
        }

        out += char
    }

    return out
}

/**
 * Parses bidData, repairing legacy rows that were corrupted on write.
 * Returns null (rather than an empty list) when the value cannot be recovered,
 * so callers can tell "no lines" apart from "failed to read the lines".
 */
export const parseBidData = (raw) => {
    if (!raw) return []

    try {
        return JSON.parse(raw)
    } catch (e) {
        try {
            return JSON.parse(repairBidDataJson(raw))
        } catch (repairError) {
            console.error('Unable to parse bidData', repairError)
            return null
        }
    }
}
